import { FunctionComponent } from "react";

import { useReportContext } from "@/stores/ReportContext";
import {
  ProfileMenu,
  ReportDetails,
  SessionSwitcher,
} from "../header/header-utils";
import { EnhancedSidebarTrigger } from "./HeaderBar3";
import { usePage } from "./PageContext";

export const RetailHeaderBar: FunctionComponent = () => {
  const { forced, reportId } = useReportContext();
  const { titles } = usePage();

  const getUrl = (path: string) => {
    if (forced) {
      return `${path}?report_id=${reportId}`;
    }
    return path;
  };

  let navigation = [
    { name: "Overview", href: getUrl("/"), current: location.pathname === "/" },
  ];

  if (forced) {
    navigation = navigation.map((item) => {
      const url = new URL(item.href, window.location.origin);
      url.searchParams.set("report_id", reportId.toString());
      return {
        ...item,
        href: url.pathname + url.search, // Including pathname and search to preserve the base path and updated query params
      };
    });
  }

  return (
    <div className="w-full bg-gray-800 flex p-2 lg:p-4 items-center">
      <EnhancedSidebarTrigger />

      <div className="flex-grow">
        {titles.length > 0 && (
          <div className="flex items-center">
            <h1 className="text-lg lg:text-2xl font-semibold text-white ml-1 lg:ml-3">
              {titles[titles.length - 1]}
            </h1>
          </div>
        )}
      </div>

      <div>
        <ReportDetails />
      </div>
      <div>
        <SessionSwitcher />
      </div>
      <div>
        <ProfileMenu />
      </div>
    </div>
  );
};
